// extracted by mini-css-extract-plugin
export default {"container":"DesktopNav--container--3+Z9C","item":"DesktopNav--item--LfrFo","loginBtn":"DesktopNav--loginBtn--XqADk","signupBtn":"DesktopNav--signupBtn--m1iBY"};